export function formatStr(template, vars) {
    return template.replace(/\{(\w+)\}/gi, function (pattern, varName) {
        return (vars && vars[varName]) || "";
    });
}
//# sourceMappingURL=string.js.map